import './Quotes.css';
import React from 'react';

function QuotesPage() {
  return (
    <div className="quotes-page">
      <h3 className="quote">Mathematics is not about numbers, equations, computations, or algorithms: it is about undrstanding. -William Paul Thurston</h3>
    </div>
  );
}

export default QuotesPage;
